export const getQueryParam = (search, name) =>
    new URLSearchParams(search).get(name);
